import { useTranslation } from '@lyearn/i18n';
import DiscardChangesDialog from '@/components/DiscardChangesDialog';

import { PreserveModalFormProps } from './types';

const PreserveModalForm: React.FC<PreserveModalFormProps> = (props) => {
  const {
    children,
    onClose,
    showDiscardDialog,
    description,
    onDiscard,
    variant = 'edit',
    title,
    secondaryAction,
  } = props;
  const { t } = useTranslation();

  return (
    <>
      {children}
      {showDiscardDialog ? (
        <DiscardChangesDialog
          footer={secondaryAction ? { secondaryAction: { label: secondaryAction } } : undefined}
          header={{
            title: title ?? (variant === 'create' ? t('Common:GoingBack') : undefined),
            description: description ?? t('Common:DiscardChanges'),
          }}
          variant={variant}
          onClose={onClose}
          onDiscard={onDiscard}
        />
      ) : null}
    </>
  );
};

export default PreserveModalForm;
